export const SEND_RESULT_RATING_MAIL_FAILURE = 'SEND_RESULT_RATING_MAIL_FAILURE';

export const sendResultRatingMailFailure = error => ({
    type: SEND_RESULT_RATING_MAIL_FAILURE,
    payload: error,
    error: true,
});
